import styles from './CharacterGridContainer.module.css';

type Props = {
  size?: number;
  borderRadius?: number | string;
};

export const CharacterGridContainer = ({
  size,
  borderRadius = '1rem',
}: Props) => {
  const colCount = 3;
  const cells = Array.from({ length: colCount * colCount }, (_, index) => (
    <div key={index} className={styles.cell} />
  ));

  return (
    <div className={styles.gridContainer} style={{ width: size, height: size }}>
      <div
        className={styles.grid}
        style={{
          gridTemplateColumns: `repeat(${colCount}, 1fr)`,
          width: size,
          height: size,
          borderRadius: borderRadius,
        }}
      >
        {cells}
      </div>
    </div>
  );
};
